/** @format */

import { configureStore } from "@reduxjs/toolkit";
import adminReducer from "./adminSlice";
import pagesViewReducer from "./pagesViewSlice";
import sidebarReducer from "./sidebarSlice"
import notificationsReducer from "./notificationsSlice";
import dashboardReducer from "./dashboardSlice";

export default configureStore({
  reducer: {
    admin: adminReducer,
    pagesView: pagesViewReducer,
    sidebar: sidebarReducer,
    notifications: notificationsReducer,
    dashboard: dashboardReducer,
  },
});
